__turbopack_context__.v({
  "dropdownContainer": "DropDown-module-scss-module__CCPqya__dropdownContainer",
});
